export const CAPSULE_LANE_HEIGHT = 18;

export const LANE_LABEL_HEIGHT_REM = 0.875;

export const CAPSULE_LABEL_HEIGHT_REM = 0.75;
